import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function FeedbackTemplatesRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    navigate('/templates', { replace: true })
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      Redirecting to templates…
    </div>
  )
}
